import { getTestId, LILAC_300 } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  campaignList: [{
    title: {
      text: ''
    },
    subtitle: {
      text: 'Share mobile number & EID'
    },
    statusCardImage: {
      imageUrl: 'https://assets.airtel.in/static-assets/airtel-widgets/e-sim/images/social-proof.png'
    },
    type: 'image',
    breakpoints: {
      xs: 4,
      lg: 3
    }
  }, {
    title: {
      text: ''
    },
    subtitle: {
      text: 'Verify your number through OTP'
    },
    statusCardImage: {
      imageUrl: 'https://assets.airtel.in/static-assets/airtel-widgets/e-sim/images/social-proof.png'
    },
    type: 'image',
    breakpoints: {
      xs: 4,
      lg: 3
    }
  }, {
    title: {
      text: ''
    },
    subtitle: {
      text: 'Activate your eSIM'
    },
    statusCardImage: {
      imageUrl: 'https://assets.airtel.in/static-assets/airtel-widgets/e-sim/images/social-proof.png'
    },
    type: 'image',
    breakpoints: {
      xs: 4,
      lg: 3
    }
  }],
  campaignTitle: 'How it works?',
  campaignTitleBreakpoints: {
    xs: 0,
    sm: 0,
    md: 0,
    lg: 3
  },
  showTitleSection: true,
  titleSectionProps: {
    title: 'How it works?',
    gridTitleColProps: {
      breakpoints: {
        lg: 0,
        xl: 0
      },
      style: {
        justifyContent: 'center'
      }
    },
    backgroundColor: LILAC_300
  }
}, getTestId('CampaignWidgetContainer'));